var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadSpeedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.48125 0C3.34951 0 0 3.35775 0 7.49985C0 11.6421 3.34951 15 7.48125 15C11.613 15 14.9625 11.6421 14.9625 7.49985C14.9625 3.35775 11.613 0 7.48125 0Z",
    fill: "#EDEDED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7548 4.04688L11.9683 4.26107L6.32786 9.29373L5.68701 8.65128L11.7548 4.04688Z",
    fill: "#D5D5D5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.12664 11.5469V12.4469H8.22889V11.5469H7.92964V12.4469H7.03189V11.5469H6.73264V12.4469H5.83489V11.5469H5.53564V12.7469H9.42589V11.5469H9.12664Z",
    fill: "#BEBEBE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.03763 1.21663C4.76288 1.37323 2.80474 2.76928 1.83936 4.73173L2.65092 5.13012C3.51381 3.38322 5.29465 2.15818 7.33912 2.10523C7.387 2.10403 7.43428 2.10523 7.48186 2.10523V1.20312C7.33478 1.20312 7.18695 1.20628 7.03763 1.21663Z",
    fill: "#EFC75E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8657 7.50312C12.8657 8.32377 12.6507 9.13408 12.3142 9.84463C12.2111 10.0624 12.2884 10.3219 12.4989 10.441L12.507 10.4455C12.741 10.5778 13.0362 10.4806 13.1512 10.2384C13.5447 9.40843 13.7657 8.46192 13.7657 7.50312C13.7657 6.44682 13.5049 5.45233 13.0464 4.57812L12.2495 4.99723C12.6421 5.74618 12.8657 6.59832 12.8657 7.50312Z",
    fill: "#E2574C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.45439 10.4466L2.46247 10.4422C2.67314 10.326 2.75035 10.0722 2.64711 9.85917C2.28217 9.10602 2.06566 8.19117 2.09978 7.29357C2.13105 6.46962 2.35205 5.69142 2.71773 4.99962L1.91634 4.57812C1.5318 5.30817 1.28627 6.12162 1.21699 6.98247C1.12437 8.13267 1.34612 9.28767 1.81025 10.2441C1.92502 10.4808 2.22023 10.576 2.45439 10.4466Z",
    fill: "#3DB39E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.48096 1.20312V2.10523C9.60174 2.10538 11.4364 3.33298 12.314 5.11948L13.1208 4.72168C12.0963 2.63683 9.95605 1.20358 7.48096 1.20312Z",
    fill: "#F4B459"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4555 3.30469L11.669 3.51889L6.32786 9.30154L5.68701 8.65909L11.4555 3.30469Z",
    fill: "#324D5B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.48104 6.75C7.06777 6.75 6.73291 7.0857 6.73291 7.5C6.73291 7.9143 7.06777 8.25 7.48104 8.25C7.8943 8.25 8.22916 7.9143 8.22916 7.5C8.22916 7.0857 7.8943 6.75 7.48104 6.75Z",
    fill: "#1E2D36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadSpeedIcon);
export default __webpack_public_path__ + "static/media/uploadSpeedIcon.ae64d1c6b00956e26e4cdd7c5e93a434.svg";
export { ForwardRef as ReactComponent };